<template>
  <footer>© Novars inc.</footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>
